import React from 'react';
import {
  FaTwitter,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
  FaGithub,
  FaHandPointRight,
} from 'react-icons/fa';

function Hero() {
  const SOCIAL = [
    {
      id: 1,
      link: 'https://twitter.com/notableprince',
      icon: <FaTwitter />,
    },
    {
      id: 2,
      link: 'https://www.facebook.com/msbtrooper',
      icon: <FaFacebook />,
    },
    {
      id: 3,
      link: 'https://www.linkedin.com/in/ayodeji-adebolu-75282418b/',
      icon: <FaLinkedin />,
    },
    {
      id: 4,
      link: 'https://www.youtube.com/@thedelectables6910',
      icon: <FaYoutube />,
    },
    {
      id: 5,
      link: 'https://wa.me/+2348100987235',
      icon: <FaWhatsapp />,
    },
    {
      id: 6,
      link: 'https://github.com/Adeyod',
      icon: <FaGithub />,
    },
  ];
  return (
    <section className=" min-h-fit md:px-0 p-5 text-center flex flex-col justify-start items-center">
      <img
        className="w-2/3 xl:w-1/3 pb-3 mt-20 animate-bounce"
        src="../images/mod5.png"
        alt="profile"
        loading="lazy"
      />
      <h2 className="text-rose-600 text-5xl font-bold uppercase">
        Adebolu Ayodeji
      </h2>
      <h3 className="py-3 text-3xl">Software Developer</h3>
      <p className="max-w-xl font-light text-gray-600 dark:text-gray-400 px-2">
        Hello <span className="animate-pulse text-4xl"></span>
        welcome to my site. I am a software developer with knowledge in
        different skills like JavaScript, NodeJs, ExpressJs, EJS, MongoDB, HTML,
        CSS, Bootstrap, tailwindcss and ReactJs. I love to work on the web
      </p>

      {/* SOCIALS */}
      <div className="flex justify-evenly py-8 lg:py-16 text-3xl w-full md:w-1/3">
        {SOCIAL.map(({ id, link, icon }) => (
          <a
            href={link}
            key={id}
            className="cursor-pointer duration-300 hover:text-kelly-green dark:hover:text-rose-600"
            target="_blank"
            rel="noopener noreferrer"
          >
            {icon}
          </a>
        ))}
      </div>

      {/* AVATAR AND RESUME */}

      <div className="flex items-center">
        <div className="flex items-center">
          <p className="mr-4 font-bold italic rounded-xl bg-gradient-to-r from-rose-500 to-teal-500 p-2">
            Resume
          </p>
          <FaHandPointRight className="text-3xl animate-pulse" />
        </div>
        <a href="../images/myUpdatedCv.pdf" download={true}>
          <img
            src="../images/downloadRemovebg.png"
            className="w-30 h-20 bg-gradient-to-b"
            alt="resume"
          />
        </a>
      </div>

      {/* CERTIFICATION */}
      <div className="pt-5 px-0 md:w-full md:px-20">
        <p className="pb-5 text-3xl underline text-kelly-green">
          CERTIFICATIONS
        </p>
        <div className="flex md:items-center md:max-w-full md:w-full flex-col md:flex-row md:justify-around md:pl-0 pl-3">
          <div className="flex justify-start pr-2">
            <FaHandPointRight className="md:text-2xl animate-ping" />
            <a
              href="https://drive.google.com/file/d/1TqVYW0XDx1CWd-kzNrzlMSIOInS2g2I6/view?usp=sharing"
              download={true}
              className="text-purple-600 underline md:text-2xl pl-4"
            >
              Intro to Back-End Development
            </a>
          </div>

          <div className="flex justify-start mt-4">
            <FaHandPointRight className="md:text-2xl animate-ping" />
            <a
              href="https://drive.google.com/file/d/1v7AiiN26S0EJEbGqHVNpyN4Yq_VeMMZ_/view?usp=sharing"
              download={true}
              className="text-purple-600 underline ml-4 md:text-2xl"
            >
              Programming in Python
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
